import { ICart } from "@features/cart/ICart";
import { getCartConfig, getCartTotal, getTotalQuantity, IDataLayerEcommerceItem, mapItems } from "./cart";
import { EDataLayerEventType, sendEvent } from "./dataLayer";
import { getProspectReference } from "@utils/storage";

export interface IDataLayerViewCartEvent {
    event: EDataLayerEventType.VIEW_CART;
    ecommerce: {
        currency: "EUR";
        items: IDataLayerEcommerceItem[];
        totalQuantity: number;
        value: number;
    };
    cartConfig: string;
    cartId: string;
}

export const sendViewCartEvent = (cart: ICart) => {
    const items = mapItems(cart.offers);
    sendEvent({
        event: EDataLayerEventType.VIEW_CART,
        ecommerce: {
            currency: "EUR",
            items,
            totalQuantity: getTotalQuantity(items),
            value: getCartTotal(cart),
        },
        cartConfig: getCartConfig(items),
        cartId: getProspectReference(),
    });
};
